<div class="main-container">
   <div class="navigation-breadcrumb">
    <a (click)="onClose()" class="breadcrumb-text">
      {{ breadcrumb.dashboard }}
    </a>
    <span class="breadcrumb-separator"> / </span>
    <span class="breadcrumb-text">{{ breadcrumb.teamComposition }}</span>
  </div>

  <div class="team-composition-container">
    <h1 class="page-title">{{ heading.Employee360 }}</h1>
    <!-- People picker — overlay drawer (zero reserved width). The docked
         edge handle below sits exactly where the drawer emerges, so the
         affordance and the motion share one spot. Closes on backdrop, ×,
         Esc, or when a person is picked. -->
    <button type="button" class="people-tab" *ngIf="!peopleDrawerOpen"
            (mouseenter)="openPeopleDrawer()" (click)="openPeopleDrawer()"
            title="Browse and switch people">
      <emerald-icon [icon]="'groups'" [fontsizeInRem]="1.05"></emerald-icon>
      <span class="people-tab__label">PEOPLE</span>
      <span class="people-tab__count" *ngIf="displayData.length">{{ displayData.length }}</span>
    </button>
    <div class="people-backdrop" *ngIf="peopleDrawerOpen" (click)="closePeopleDrawer()"></div>
    <aside class="people-drawer" [class.people-drawer--open]="peopleDrawerOpen"
           (mouseleave)="closePeopleDrawer()"
           (keydown.escape)="closePeopleDrawer()">
      <div class="people-drawer__head">
        <span class="people-drawer__title">People</span>
        <button type="button" class="people-drawer__close" aria-label="Close"
                (click)="closePeopleDrawer()">×</button>
      </div>

      <div class="filter-dropdown">
        <iskill-searchable-select
          [options]="teamOptions"
          placeholder="All Teams"
          [value]="selectedTeamLabel"
          (valueChange)="onTeamPick($event)">
        </iskill-searchable-select>
      </div>

      <div class="people-search">
        <emerald-icon [icon]="'search'" [fontsizeInRem]="1" class="people-search-icon"></emerald-icon>
        <input
          type="text"
          class="people-search-input"
          placeholder="Search people…"
          aria-label="Search people"
          [value]="filterValue"
          (keyup)="search($event)" />
        <button
          *ngIf="filterValue && filterValue.length > 0"
          type="button"
          class="people-search-clear"
          aria-label="Clear search"
          (click)="clearInput()">×</button>
      </div>

      <div class="people-drawer__list">
        <div
          class="profile-section-container"
          *ngFor="let profile of displayData"
          [class.active]="activeProfile === profile"
          (click)="onProfileClick(profile)"
          (keyup.enter)="onProfileClick(profile)"
          tabindex="0"
        >
          <div class="profile-section">
            <div class="profile-info">
              <div class="profile-name">{{ profile.name }}</div>
              <div class="profile-designation">{{ profile.jobTitle }}</div>
            </div>
            <emerald-icon
              [icon]="'arrow_right'"
              class="profile-arrow"
            ></emerald-icon>
          </div>
        </div>
      </div>
    </aside>

    <div class="team-composition-layout">
      <div class="right-container">
        <ng-container *ngIf="employeeData; else noDataTemplate">
          <!-- Employee 360 — the record view. Aggregates iSkill KPIs,
               competency movement, productivity and RTO; Team-Composition
               actions (Add/View Feedback for CWR) project into its header. -->
          <app-employee-360 *ngIf="currentPsId" [employeeId]="currentPsId" [embedded]="true"></app-employee-360>

        </ng-container>
        <ng-template #noDataTemplate>
          <section class="records-container" aria-label="Records section">
            <div class="empty-state">
              <h2 class="empty-state-title">
                {{ TimeCompositionListLabels.NO_DATA_FOUND }}
              </h2>
              <img
                [src]="imageSrc"
                alt="No records illustration"
                class="empty-state-image"
              />
            </div>
          </section>
        </ng-template>
      </div>
    </div>
  </div>
  <app-change-team
    *ngIf="showChangeTeamModal"
    [empId]="currentPsId || ''"
    (close)="closeChangeTeamModal()"
    (submitted)="handleChangeTeamSubmitted()"
    [currentProjects]="projectData.workingOn"
  ></app-change-team>
  
    <app-modal-wrapper [showModal]="showContractorProfileModal">
    <app-contractor-profile
      *ngIf="showContractorProfileModal"
      [contractorId]="selectedContractorId"
      (close)="showContractorProfileModal = false"
      [navigationSourceTeam]="'team-composition'"
      (closingDashboard)="onClose()"
    ></app-contractor-profile>
  </app-modal-wrapper>

  <app-new-beginnings
    *ngIf="showNewBeginningsModal"
    [employeeDetails]="employeeData"
    (close)="closeNewBeginningsModal()"
    (requestCreated)="handleNewBeginnings()"
  ></app-new-beginnings>
</div>
